export default __webpack_public_path__ + "static/media/Rectangle 42.b5950eea.svg";